import { CampaignStore } from './schema/CampaignStore';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

const campaignStoreData: CampaignStore<any> = {
    campaignVisibleMap: new ObservableMap(),
    campaignObjectsCache: {},
};

const getStore = createStore<CampaignStore<any>>('campaigns', campaignStoreData);

export const campaignStore = getStore();
export default getStore;
